import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

export type RegistryTableColCheckboxProps = ComponentPropsWithoutRef<'colgroup'>;

export const createRegistryTableColCheckbox = () => {
	const RegistryTableColCheckbox = forwardRef<HTMLTableColElement, RegistryTableColCheckboxProps>(
		({ className, ...props }, ref) => (
			<col
				ref={ref}
				className={clsx('registry-table-col-checkbox', className)}
				{...props}
			/>
		),
	);

	return RegistryTableColCheckbox;
};
